
import { Vue } from "vue-class-component";

export default class SttHanging extends Vue {}
